export const SET_OPENING_BALANCE_DATA = "SET_OPENING_BALANCE_DATA";
export const SET_OPENING_BALANCE_ID = "SET_OPENING_BALANCE_ID";
